export var TypeQuickActions = /*#__PURE__*/function (TypeQuickActions) {
  TypeQuickActions["NZStart"] = "nz-start";
  TypeQuickActions["PopularRequests"] = "popular-request";
  TypeQuickActions["QuickReplies"] = "quick-replies";
  TypeQuickActions["Hidden"] = "";
  return TypeQuickActions;
}({});